const CareerSection = () => {
  return (
    <section className="about about--style1 bg-color xts-section">
      <div className="container">
        <div className="about__wrapper">
          <div className="row gx-5 gy-4 gy-sm-0 align-items-center">

            {/* Left Image */}
            <div className="col-lg-6">
              <div
                className="about__thumb pe-lg-5"
                data-aos="fade-right"
                data-aos-duration="800"
              >
                <div className="about__thumb-inner">
                  <div className="about__thumb-image floating-content">
                    <img
                      className="dark"
                      src="assets/images/about/career.jpg"
                      alt="about"
                    />
                  </div>
                </div>
              </div>
            </div>

            {/* Right Content */}
            <div className="col-lg-6">
              <div
                className="about__content"
                data-aos="fade-left"
                data-aos-duration="800"
              >
                <div className="about__content-inner">
                  <h2 className="meet-oppurtanity">
                    We offer a premium on <span className="style2">high performance.</span>
                  </h2>

                  <p className="text-justify">
                    We have a place for young people with a burning desire to achieve
                    excellence in their field of operation viz - jobbers, operators,
                    computer specialists, accounts, etc. You should be qualified and
                    passionate about stock operations.
                  </p>

                  <p className="text-justify">
                    You need to have open-mindedness, drive and creativity. We expect
                    you to offer solutions that help us meet our clients' needs and
                    achieve customer delight. Of course, you are fast in response.
                  </p>

                  <p className="text-justify">
                    Please apply online or e-mail your resume to{" "}
                    <a href="mailto:asiaticstock@gmail.com">
                      asiaticstock@gmail.com
                    </a>
                    . We will get back to you as soon as possible.
                  </p>

                  <a
                    href="contact"
                    className="trk-btn trk-btn--border trk-btn--primary mt-0"
                  >
                    Connect
                  </a>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </section>
  );
};

export default CareerSection;
